import { render, staticRenderFns } from "./MonetaryView.vue?vue&type=template&id=d96a3a58&"
import script from "./MonetaryView.vue?vue&type=script&lang=js&"
export * from "./MonetaryView.vue?vue&type=script&lang=js&"
import style0 from "./MonetaryView.vue?vue&type=style&index=0&id=d96a3a58&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports